import { render, staticRenderFns } from "./jiang.vue?vue&type=template&id=6a8a3bae&scoped=true&"
import script from "./jiang.vue?vue&type=script&lang=js&"
export * from "./jiang.vue?vue&type=script&lang=js&"
import style0 from "./jiang.vue?vue&type=style&index=0&id=6a8a3bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a3bae",
  null
  
)

export default component.exports